export enum UserEnum {
  INTERVIEWER = 'Interviewer',
  OPERATIONS = 'Operations',
  CANDIDATE = 'Candidate',
  GHOST = 'Ghost',
  DEFAULT = '',
  BOT = 'Bot',
}
